<template>
  <v-card>
    <v-card-title class="headline grey lighten-3" primary-title>
      <v-flex v-if="!Update_Details">
        <v-icon style="padding-right: 24px;">note_add</v-icon>Add
      </v-flex>
      <v-flex v-else>Update</v-flex>
    </v-card-title>
    <v-card-text style="padding: 60px 30px;padding-bottom: 0px;">
      <v-flex pt-5>
        <v-text-field label="Category Name" v-model="Category_Name"></v-text-field>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="!Update_Details" @click="AddCategory">Add Category</v-btn>
      <v-btn color="primary" v-else @click="UpdateCategory">Update Category</v-btn>
      <v-btn color="primary" flat @click="ClearForm">Clear</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      Update_Details: false,
      Category_Id: "",
      Category_Name: ""
    };
  },
  methods: {
    ClearForm() {
      this.Category_Id = "";
      this.Category_Name = "";
      this.Update_Details = false;
    },
    AddCategory() {
      let data = {};
      data["Category_Name"] = this.Category_Name;
      data["Category_URL"] = this.Category_Name.toLowerCase().split(" ").join("-");

      let Duplicate = this.$store.getters.GetCategoryList.find(x => x['Category_URL'] == data["Category_URL"])
      if (this.Category_Name && !Duplicate) {
        
        this.$http.post(`${this.$store.getters.GetProductionUrl}/category/addcategory`,data)
          .then(response => {

              this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Added Category", Color: "green", Close: false });
              this.$store.commit("SetIndividualCategory", response["data"]["response"]);
              this.ClearForm();
          })
          .catch(err => {

              this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Add Data", Color: "red", Close: false });
          });
      } else {

        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Check the Category Name", Color: "red", Close: false });
      }
    },
    OpenToUpdate(Item) {
      this.Update_Details = true;
      this.Category_Name = Item["Category_Name"];
      this.Category_Id = Item["_id"];
    },
    UpdateCategory() {
      let data = {};
      data["Category_Id"] = this.Category_Id;
      data["update"] = {};
      data["update"]["Category_Name"] = this.Category_Name;
      data["update"]["Category_URL"] = this.Category_Name.toLowerCase()
        .split(" ")
        .join("-");

      if (this.Category_Id && this.Category_Name) {
        
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/category/updatecategory`,
            data
          )
          .then(response => {
            this.$store.commit(
              "UpdateIndividualCategory",
              response["data"]["response"]
            );
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Successfully Updated Category",
              Color: "green",
              Close: false
            });
            this.ClearForm();
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Error While Updating Category",
              Color: "red",
              Close: false
            });
          });
      } else {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Error While Updating Category",
          Color: "red",
          Close: false
        });
      }
    }
  }
};
</script>
<style scoped>
</style>
